import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';

// Unregister any existing service workers to prevent stale caching
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then(registrations => {
    for (const registration of registrations) {
      registration.unregister();
      console.log('[SW] Unregistered service worker:', registration.scope);
    }
  });
  // Also clear caches
  if ('caches' in window) {
    caches.keys().then(names => {
      for (const name of names) {
        caches.delete(name);
        console.log('[Cache] Deleted cache:', name);
      }
    });
  }
}

bootstrapApplication(App, appConfig)
  .catch((err) => console.error(err));
